import { HttpClientResponse } from './http-client-response.js';

export async function bodyAsJson(res: HttpClientResponse): Promise<unknown> {
  const body = await res.bodyAsString();
  return JSON.parse(body);
}
